/* eslint-disable react/prop-types */
import DynamicForm, { PageType } from '@apollo/dynamic-form';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import { element } from 'prop-types';
import { actionConfig } from '../Config/actionConfig';
import ContactUsRenderer, {
  ContactUsRendererTester,
} from './ContactUsRenderer';
// import { countriesList } from '../../../util/util';

function ContactUs({
  initialData,
  actionType,
  companyDetails,
  customStyle = null,
  isOpen = false,
  handleContactUsClear,
  programPath,
}) {
  const { solution, allCountries, isMobile } = useSelector((state) => ({
    solution: state.facets.solution,
    allCountries: state.facets.location.allCountries,
    isMobile: state.facets.isMobile,
  }));
  const renderers = [
    {
      tester: ContactUsRendererTester,
      renderer: ContactUsRenderer,
    },
  ];
  const [formContextState, setFormContextState] = useState({});

  const setFormContext = ({ setFormData }) => {
    setFormContextState({ setFormData });
  };

  const lifecycleHooks = { setFormContext };

  useEffect(() => {
    if (formContextState.setFormData) {
      formContextState.setFormData({ ...initialData }, false);
    }
  }, [formContextState, initialData]);

  const { jsonConfig } = actionConfig[actionType] || {};

  return (
    <DynamicForm
      pages={{
        type: 'Page',
        options: {
          path: '/',
          container: { wrapperStyle: { height: 'fit-content' } },
          schema: jsonConfig?.options.schema,
          uischema: {
            type: 'Div',
            elements: [
              {
                type: 'ContactUsModal',
              },
              {
                type: 'VerticalLayout',
                options: {
                  style: {
                    display: 'none',
                  },
                },
                elements: [
                  {
                    type: 'SubmitButton',
                    options: {
                      label: 'Log In',
                      submitUrl:
                          'https://dynamic-forms-demo.vercel.app/api/login',
                    },
                  },
                ],
              },
            ],
          },
        },
      }}
      type={PageType.SINGLE_PAGE}
      dynamicData={{
        data: {
          initialData,
          actionType,
          companyDetails,
          customStyle,
          isOpen,
          handleContactUsClear,
          programPath,
          isMobile,
        },
      }}
      config={{
        reduxState: {
          formContextState,
          countries: allCountries?.map((item) => ({
            label: item.name,
            value: item.name,
          })),
          solutions: solution.options?.map((item) => ({
            label: item.name,
            value: item.name,
          })),
        },
      }}
      renderers={renderers}
      lifecycleHooks={lifecycleHooks}
    />

  );
}

export default ContactUs;
